// Trust bar: on mobile, rotate through the signals one at a time.
// Falls back to a swipeable row when the visitor prefers reduced motion,
// and to a single static signal if this script never runs.

function initTrustBar(root) {
  if (root.dataset.trustbarInit) return;
  root.dataset.trustbarInit = '1';

  var items = Array.prototype.slice.call(root.querySelectorAll('.trust-bar__item'));
  if (items.length < 2) return;

  var mqMobile = window.matchMedia('(max-width: 749px)');
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var idx = 0;
  var timer = null;

  function show(i) {
    for (var n = 0; n < items.length; n++) {
      items[n].classList.toggle('is-active', n === i);
    }
  }

  function start() {
    if (timer) return;
    root.classList.add('is-rotating');
    idx = 0;
    show(0);
    timer = window.setInterval(function () {
      idx = (idx + 1) % items.length;
      show(idx);
    }, 3000);
  }

  function stop() {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
    root.classList.remove('is-rotating');
    for (var n = 0; n < items.length; n++) {
      items[n].classList.remove('is-active');
    }
  }

  function update() {
    if (mqMobile.matches) {
      if (mqReduce.matches) {
        stop();
        root.classList.add('is-scroll');
      } else {
        root.classList.remove('is-scroll');
        start();
      }
    } else {
      stop();
      root.classList.remove('is-scroll');
    }
  }

  function listen(mq, fn) {
    if (mq.addEventListener) mq.addEventListener('change', fn);
    else if (mq.addListener) mq.addListener(fn);
  }

  update();
  listen(mqMobile, update);
  listen(mqReduce, update);
}

function bootTrustBars(scope) {
  (scope || document).querySelectorAll('.trust-bar').forEach(initTrustBar);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    bootTrustBars();
  });
} else {
  bootTrustBars();
}

// Re-initialise when a section is (re)loaded in the theme editor.
document.addEventListener('shopify:section:load', function (e) {
  bootTrustBars(e.target);
});
